<template>
  <div>
    <h2 class="text-center">Backers &#38; Partners</h2>
    <div class="marquee-wrapper">
      <div class="marquee-content">
        <div class="marquee-list">
          <!-- Backers -->
          <a href="https://www.cloudjetsolutions.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/cloudjet.png"  alt="Cloudjet logo">
          </a>
          <a href="https://altair-alpha.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/altair-alpha.png"  alt="Altair Alpha logo">
          </a>
          <a href="https://cryptowar.network/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/cryptowar.png"  alt="Altair Alpha logo">
          </a>

          <!-- Partners -->
          <a href="https://shop.ccfound.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/partners/ccfound.png"  alt="CCFound logo">
          </a>
          <a href="https://quarashi.network/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/partners/quarashi.png"  alt="Quarashi logo">
          </a>
        </div>
        <div class="marquee-list">
          <!-- Backers -->
          <a href="https://www.cloudjetsolutions.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/cloudjet.png"  alt="Cloudjet logo">
          </a>
          <a href="https://altair-alpha.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/altair-alpha.png"  alt="Altair Alpha logo">
          </a>
           <a href="https://cryptowar.network/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/backers/cryptowar.png"  alt="Altair Alpha logo">
          </a>

          <!-- Partners -->
          <a href="https://shop.ccfound.com/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/partners/ccfound.png"  alt="CCFound logo">
          </a>
          <a href="https://quarashi.network/" class="marquee-item" target="_blank" rel="noopener noreferrer">
            <img class="bnp-logo" loading="lazy" src="../../../assets/images/backers-and-partners/partners/quarashi.png"  alt="Quarashi logo">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CFooterBackersAndPartners',
}
</script>